import React, { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import DashboardList from 'components/DashboardList/DashboardList';
import DashboardsModalWrapper from 'components/DashboardsModalWrapper/DashboardsModalWrapper';
import { useFetchActiveDashboards } from 'routes/AllDashboards/hooks/getDashboardsList';
import { useSelector } from 'store/hooks';
import FavouriteDashboardModalItem from './FavouriteDashboardModalItem';
import Loading from 'components/Loading';

type Props = {
    open: boolean;
    onClose: () => void;
};

const FavouriteDashboardsModal = ({ open, onClose }: Props): JSX.Element => {
    const [filter, setFilter] = useState('');
    const { data: allDashboards, isLoading } = useFetchActiveDashboards();

    const homeDashboardSlug = useSelector(
        (state) => state.vision.user.homeDashboardSlug,
    );

    const { t } = useTranslation();
    const onFilterChange = (e: ChangeEvent<HTMLInputElement>): void =>
        setFilter(e.target.value);

    const modalContent = isLoading ? (
        <Loading />
    ) : (
        <>
            <TextField
                value={filter}
                autoFocus
                variant="outlined"
                margin="dense"
                size="small"
                fullWidth
                label={t('home.searchDashboard')}
                onChange={onFilterChange}
            />
            <DashboardList
                dashboards={allDashboards ?? []}
                dashboardItemRender={(dashboard) =>
                    FavouriteDashboardModalItem({ dashboard, filter })
                }
                homeDashboardSlug={homeDashboardSlug}
            />
        </>
    );

    return (
        <DashboardsModalWrapper open={open} onClose={onClose}>
            <DialogContent>{modalContent}</DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('common.close')}</Button>
            </DialogActions>
        </DashboardsModalWrapper>
    );
};

export default FavouriteDashboardsModal;
